<template>
  <div class="box-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-center">
        <span class="page-title">Member List V2</span>
        <div class="ml-2 d-flex align-items-center">
          <input
            v-model="startDate"
            type="date"
            class="form-control form-control-sm mr-2"
            style="max-width: 160px;"
          >
          <input
            v-model="endDate"
            type="date"
            class="form-control form-control-sm"
            style="max-width: 160px;"
          >
        </div>
      </div>
      <div class="right-of-header">
        <div class="d-flex">
          <div class="ele-search2">
            <i class="fa fa-search"></i>
            <input
              v-model.trim="keyword"
              @keypress.enter="onSearch"
              type="text"
              name="search"
              placeholder="Search name or phone"
              class="ele-search2-input"
            >
          </div>
          <button class="btn btn-sm btn-primary ml-2" @click="onSearch">Filter</button>
          <button class="btn btn-sm btn-light ml-2" @click="clearDateFilter">Clear</button>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="row pb-2">
        <div class="col-md-6 box-info-bar px-2">
          <div class="info-bar accent-purple">
            <div class="row no-gutters">
              <div class="col-md-6 my-auto">
                <div class="info-bar-text info-bar-desc text-left">
                  <span class="text-nowrap text-color-dark">Total Balance</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-bar-text info-bar-value">{{ totalCurrentMoney }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100" style="overflow-x: auto;">
        <table id="tb_datalist" class="table table-hover">
          <thead>
            <tr>
              <th style="width: 140px; min-width: 140px;"></th>
              <th style="width: 70px; min-width: 70px;">
                <div class="text-btn header-text text-center" @click="toggleSort('id')">
                  <span>No.</span>
                  <i class="fa" :class="getSortIcon('id')"></i>
                </div>
              </th>
              <th style="width: 110px; min-width: 110px;">Registered</th>
              <th style="width: 90px; min-width: 90px;">Type</th>
              <th style="width: 150px; min-width: 150px;">Last Login</th>
              <th style="width: 120px; min-width: 120px;">As</th>
              <th>Name</th>
              <th style="width: 180px; min-width: 180px;">Phone</th>
              <th>
                <div class="text-btn header-text" @click="toggleSort('current_money')">
                  <span>Balance</span>
                  <i class="fa" :class="getSortIcon('current_money')"></i>
                </div>
              </th>
              <th style="width: 100px; min-width: 100px;">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isLoading">
              <td colspan="10" class="text-center">Loading...</td>
            </tr>
            <tr v-else-if="listMember.length === 0">
              <td colspan="10" class="text-center">No data</td>
            </tr>
            <tr v-else v-for="(item, idx) in listMember" :key="item.id">
              <td class="align-middle">
                <a :href="baseUrl + '/admin/member/detail/' + item.id" class="btn btn-table">Detail</a>
              </td>
              <td class="text-center">{{ getRowNo(idx) }}</td>
              <td class="text-center">{{ formatDate(item.created_at) }}</td>
              <td class="text-center">{{ getMemberTypeText(item.member_type) }}</td>
              <td class="text-center">{{ formatDateTime(item.last_login) }}</td>
              <td class="text-center">{{ getRegisterAsText(item.register_as) }}</td>
              <td>{{ item.member_name || '-' }}</td>
              <td>{{ item.telephone || '-' }}</td>
              <td>{{ item.current_money || '0.00' }}</td>
              <td>{{ getActiveText(item.is_active) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-end align-items-center" v-if="lastPage > 1">
          <button class="btn btn-sm btn-light mr-2" :disabled="currentPage <= 1" @click="goPage(currentPage - 1)">
            Prev
          </button>
          <span class="mr-2">Page {{ currentPage }} / {{ lastPage }}</span>
          <button class="btn btn-sm btn-light" :disabled="currentPage >= lastPage" @click="goPage(currentPage + 1)">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    baseUrl: {
      type: String,
      required: true
    },
    storagePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listMember: [],
      startDate: null,
      endDate: null,
      keyword: '',
      pageSize: 50,
      currentPage: 1,
      lastPage: 1,
      totalCurrentMoney: '0.00',
      sortValue: ['id', 'DESC'],
      isLoading: false,
      requestSeq: 0
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    onSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    clearDateFilter() {
      this.startDate = null;
      this.endDate = null;
      this.currentPage = 1;
      this.loadList();
    },
    goPage(pageNo) {
      if (pageNo < 1 || pageNo > this.lastPage) return;
      this.currentPage = pageNo;
      this.loadList();
    },
    toggleSort(sortField) {
      let sortDir = 'DESC';
      if (this.sortValue[0] === sortField) {
        sortDir = this.sortValue[1] === 'DESC' ? 'ASC' : 'DESC';
      }
      this.sortValue = [sortField, sortDir];
      this.currentPage = 1;
      this.loadList();
    },
    getSortIcon(field) {
      if (this.sortValue[0] !== field) return 'fa-chevron-down';
      return this.sortValue[1] === 'DESC' ? 'fa-chevron-up active' : 'fa-chevron-down active';
    },
    loadList() {
      const seq = ++this.requestSeq;
      this.isLoading = true;
      axios.post(`${this.baseUrl}/admin/api/list-member`, {
        startDate: this.startDate,
        endDate: this.endDate,
        keyword: this.keyword,
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        sort: JSON.stringify(this.sortValue)
      }).then(({ data }) => {
        if (seq !== this.requestSeq) return;
        const rows = Array.isArray(data && data.data) ? data.data : [];
        this.listMember = rows;
        this.lastPage = parseInt((data && data.totalPage) || 1, 10);
        this.totalCurrentMoney = (data && data.total_current_money) || '0.00';
      }).catch(() => {
        if (seq !== this.requestSeq) return;
        this.listMember = [];
        this.lastPage = 1;
      }).finally(() => {
        if (seq === this.requestSeq) {
          this.isLoading = false;
        }
      });
    },
    getRowNo(index) {
      return ((this.currentPage - 1) * this.pageSize) + index + 1;
    },
    formatDate(value) {
      if (!value) return '-';
      if (window.moment) return window.moment(value).format('DD/MM/YYYY');
      return value;
    },
    formatDateTime(value) {
      if (!value) return '-';
      if (window.moment) return window.moment(value).format('DD/MM/YYYY HH:mm');
      return value;
    },
    getMemberTypeText(type) {
      if (type === 'borrower') return 'Borrower';
      if (type === 'lender') return 'Lender';
      return '-';
    },
    getRegisterAsText(value) {
      if (value === 'personal') return 'Personal';
      if (value === 'juristic_person') return 'Corporate';
      return '-';
    },
    getActiveText(status) {
      if (status === null || typeof status === 'undefined') return 'Pending';
      return Number(status) === 1 ? 'Active' : 'Inactive';
    }
  }
};
</script>
